export type FrontendVersionPayload = {
    version?: unknown;
};

export const parseRemoteRelease = (
    payload: FrontendVersionPayload | null | undefined,
): string | null => {
    if (!payload || typeof payload.version !== 'string') {
        return null;
    }

    const version = payload.version.trim();
    return version.length > 0 ? version : null;
};

export const isNewRelease = (
    currentRelease: string | null | undefined,
    remoteRelease: string | null,
): boolean => {
    const normalizedCurrent = currentRelease?.trim();
    return Boolean(
        normalizedCurrent &&
        remoteRelease &&
        normalizedCurrent !== remoteRelease,
    );
};

export const isJsonContentType = (
    contentType: string | null | undefined,
): boolean => Boolean(contentType?.includes('application/json'));

export const isSnoozeExpired = (
    snoozedUntil: number | null,
    now = Date.now(),
): boolean => snoozedUntil !== null && now >= snoozedUntil;

export const shouldShowUpdateNotice = ({
    currentRelease,
    remoteRelease,
    snoozedUntil,
    now = Date.now(),
}: {
    currentRelease: string | null | undefined;
    remoteRelease: string | null;
    snoozedUntil: number | null;
    now?: number;
}): boolean => {
    if (!isNewRelease(currentRelease, remoteRelease)) {
        return false;
    }
    return snoozedUntil === null || isSnoozeExpired(snoozedUntil, now);
};
